<template>
  <div>
    <!-- 二次封装表格 -->
    <el-table
      v-loading="loadingTable"
      :data="dataList"
      :max-height="height?number:tableHeight"
      :border="true"
      :header-cell-style="tableHeader"
    >
      <!-- 多选 -->
      <el-table-column v-if="showSelection" type="selection" width="55"></el-table-column>
      <!-- 序号 -->
      <el-table-column
        label="序号"
        type="index"
        width="50"
        align="left"
        v-if="showIndex"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        align="left"
        show-overflow-tooltip
        :min-width="item.width"
        :formatter="item.formatter"
        :label="item.label"
        :sortable="item.sortable ? item.sortable : false"
      >
        <!-- 根据item.render值进行判断 是否需要对props进行另外的操作 -->
        <template slot-scope="scope">
          <slot v-if="item.render ? item.render : false" :row="scope.row" :name="item.prop"></slot>
          <div v-else class="line-limit-length">{{scope.row[item.prop]}}</div>
        </template>
      </el-table-column>

      <!-- // 单独写了操作 根据条件判断是否需要操作列 -->
      <el-table-column label="操作" align="left" v-if="showOperation" :min-width="handleWidth">
        <template slot-scope="scope">
          <slot :row="scope.row" name="handle"></slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'Tablecolumn',

  props: {
    height: { // 小表格378
      default: false,
      type: Boolean
    },
    showIndex: { // 是否要序号
      default: false,
      type: Boolean
    },
    loadingTable: {
      default: false,
      type: Boolean
    },

    dataList: { // 数据
      type: Array,
      default: function () {
        return []
      },
      require: true
    },

    columnList: {
      type: Array,
      default: function () {
        return []
      },
      require: true
    },

    handleWidth: {
      type: String,
      default: '10'
    },

    showSelection: { // 多选
      default: false,
      type: Boolean
    },

    showOperation: { // 是否需要操作列
      default: false,
      type: Boolean
    },

    number: {
      default: 300,
      type: Number
    }
  },
  data () {
    return {
      tableHeight: window.innerHeight - this.number
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.fullHeight = window.innerHeight - that.number
        that.tableHeight = window.fullHeight
      })()
    }
  },

  watch: {
    dataList (val) {
    },
    fullHeight (val) {
      if (!this.timer) {
        this.tableHeight = val
        this.timer = true
        const that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  },
  methods: {

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
    <style>
</style>
